export default __webpack_public_path__ + "static/media/self-square.efb38b80.jpg";